(() => {
  const ROOT_SELECTOR = '[data-k18-brand-marquee]';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  function initMarquee(root) {
    if (!root || root._k18BrandMarqueeDestroy) return;

    const control = root.querySelector('[data-k18-brand-marquee-control]');
    const mediaQuery = window.matchMedia(REDUCED_MOTION_QUERY);
    let paused = root.dataset.paused === 'true';

    function updateControl() {
      root.dataset.paused = String(paused);
      if (control) {
        control.setAttribute('aria-pressed', String(paused));
        control.setAttribute('aria-label', paused ? 'Afspil tekstbjælke' : 'Pause tekstbjælke');
      }
    }

    function onControlClick() {
      if (mediaQuery.matches) return;
      paused = !paused;
      updateControl();
    }

    function onMotionChange() {
      if (mediaQuery.matches) {
        paused = false;
        updateControl();
      }
    }

    control?.addEventListener('click', onControlClick);
    mediaQuery.addEventListener('change', onMotionChange);
    updateControl();

    root._k18BrandMarqueeDestroy = () => {
      control?.removeEventListener('click', onControlClick);
      mediaQuery.removeEventListener('change', onMotionChange);
      delete root._k18BrandMarqueeDestroy;
    };
  }

  function initWithin(container) {
    if (!container) return;
    if (container.matches?.(ROOT_SELECTOR)) initMarquee(container);
    container.querySelectorAll?.(ROOT_SELECTOR).forEach(initMarquee);
  }

  function destroyWithin(container) {
    if (!container) return;
    const roots = [];
    if (container.matches?.(ROOT_SELECTOR)) roots.push(container);
    container.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));
    roots.forEach((root) => root._k18BrandMarqueeDestroy?.());
  }

  function bindThemeEvents() {
    if (window._k18BrandMarqueeThemeEventsBound) return;
    window._k18BrandMarqueeThemeEventsBound = true;
    document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
  }

  function boot() {
    initWithin(document);
    bindThemeEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
